import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import cx from "classnames";
import records from "../../Services/records";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrashAlt,
  faSave,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { toast, Slide } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import Portal from "../../Utils/portals";
import { appContext } from "../../Utils/context";
import {
  Input,
  Row,
  Col,
  Card,
  CardHeader,
  Button,
  Table,
  Modal,
  ModalBody,
} from "reactstrap";

function List({ show, setShow }) {
  const history = useHistory()
  const { myLists, setMyLists, user, setUser } = useContext(appContext);
  const [listName, setListName] = useState("");
  const [listNameForAdd, setListNameForAdd] = useState("");
  const [alert, setAlert] = useState(false);
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState({});
  const [recordCount, setRecordCount] = useState("");
  const [specificId, setSpecificListId] = useState(null);

  const toggleShow = () => {
    setShow(!show);
    setListName("");
    setListNameForAdd("");
  };

  const handleOpen = (id, val) => {
    // setOpen((prevState) => ({ ...prevState, [id]: !prevState[id] }));
    setOpen({ [id]: val });
  };
  const addList = () => {
    if (listNameForAdd !== "") {
      const info = {
        user_id: user.id,
        list_name: listNameForAdd,
        list_type: "user_lists",
        extra: "",
      };
      records
        .postListName(info)
        .then((res) => {
          setMyLists(res.data);
          setListNameForAdd("");
          notify22("New List Added", "success");
        })
        .catch((e) => {
          console.log("error", e.data);
        });
    } else {
      notify22("Add Name First", "error");
    }
  };

  const editMylist = (v) => {
    const info = {
      list_name: listName,
      id: v?.id,
    };
    records
      .patchListName(info)
      .then((res) => {
        const updatedList = myLists.map((obj, k) => {
          if (obj.id === v?.id) {
            return res.data;
          }
          return obj;
        });
        setMyLists(updatedList);
        handleOpen(v?.id, false);
        setAlert(false);
        setEdit(false);
        setListName("");
        notify22("List Name Updated", "success");
      })
      .catch((e) => {
        console.log("error", e.data);
      });

    // const updatedList = myLists.map((obj, k) => {
    //   if (obj.id === v?.id) {
    //     return { ...obj, label: listName }
    //   }
    //   return obj
    // })

    // setMyLists(updatedList)
    // handleOpen(v?.id, false)
    // setListName("")
    // notify22("List Name Updated", "success")
  };

  const deleteList = () => {
    records
      .deleteListName({ id: specificId })
      .then((res) => {
        const updatedList = myLists.filter((obj) => {
          return obj.id !== specificId;
        });
        setMyLists(updatedList);
        setAlert(false);
        notify22("List Deleted", "success");
      })
      .catch((e) => {
        console.log("error", e.data);
      });
  };

  const handleAlmChange = (id, alm) => {
    const info = {
      is_alm_active: alm,
      id: id,
    };
    records
      .patchListName(info)
      .then((res) => {
        const updatedList = myLists.map((obj, k) => {
          if (obj.id === id) {
            return res.data;
          }
          return obj;
        });
        setMyLists(updatedList);
        records
          .getUserProfile()
          .then((res) => {
            setUser(res.data);
          })
          .catch((err) => {
            console.log("error", err.data);
          });
        notify22("Updated", "success");
      })
      .catch((err) => {
        notify22('Your ALM limit exceeds', "error"); 
        history.push('/settings?next=plans')
      });
  };

  const notify22 = (msg, type) =>
    toast(msg, {
      transition: Slide,
      autoClose: 5000,
      position: "top-right",
      type: type,
    });

  return (
    <>
      <Modal isOpen={show} toggle={toggleShow} style={{ minWidth: "50%" }}>
        <Card className="mb-2">
          <CardHeader className="card-header-tab">
            <div className="card-header-title font-size-lg text-capitalize fw-normal">
              <i className="header-icon lnr-file-add icon-gradient bg-happy-green">
                {" "}
              </i>
              <span className="menu-header-title text-capitalize">
                Add / Edit List
              </span>
            </div>
            <Button className=" me-3 border-0 btn-transition position-absolute end-0" outline color="secondary" title=" Cancel" onClick={toggleShow}>
                                        <FontAwesomeIcon icon={faTimes} size="2x" />
                                    </Button>
          </CardHeader>
        </Card>
        <ModalBody>
          <Row className="g-1">
            <Col md="12" className="">
              <Input
                type="text"
                value={listNameForAdd}
                placeholder="List Name"
                onChange={(e) => setListNameForAdd(e.target.value)}
              />
            </Col>
            <Col md="12" style={{ height: "300px", overflowY: "auto" }}>
              <Table hover size="sm">
                <thead>
                  <tr>
                    <th>No #</th>
                    <th>List Name</th>
                    <th>List Type</th>
                    <th>Record Count</th>
                    {user?.is_alm_allowed && <th>ALM</th>}
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {myLists?.map((v, k) => (
                    <tr key={k}>
                      <td className="fw-bold">{k + 1}</td>

                      <td>
                        {open[v?.id] ? (
                          <Input
                            value={open[v?.id] ? listName : v?.list_name}
                            type="text"
                            onChange={(e) => setListName(e.target.value)}
                          />
                        ) : (
                          v?.list_name
                        )}
                      </td>
                      <td>
                        {v?.list_type
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </td>
                      <td className="fw-bold">{v?.record_count}</td>

                      {user?.is_alm_allowed && (
                        <td>
                         {v?.list_type === 'Sold' ? '' : <div
                            className="switch has-switch"
                            data-on-label="ON"
                            data-off-label="OFF"
                            onClick={() =>
                              handleAlmChange(v?.id, !v?.is_alm_active)
                            }
                          >
                            <div
                              className={cx("switch-animate", {
                                "switch-on": v?.is_alm_active,
                                "switch-off": !v?.is_alm_active,
                              })}
                            >
                              <input type="checkbox" />
                              <span className="switch-left bg-success">
                                Yes
                              </span>
                              <label>&nbsp;</label>
                              <span className="switch-right bg-success">
                                No
                              </span>
                            </div>
                          </div>}
                        </td>
                      )}
                      <td className="text-center" style={{ width: "30%" }}>
                        {open[v?.id] ? (
                          <>
                            <Button
                              className="border-0 btn-transition"
                              outline
                              title="Cancel"
                              onClick={() => {
                                handleOpen(v.id, false);
                                setListName("");
                              }}
                            >
                              <FontAwesomeIcon icon={faTimes} size="1x" />{" "}
                              Cancel
                            </Button>
                            <Button
                              className="border-0 btn-transition"
                              outline
                              color="success"
                              title="Add List"
                              onClick={() => {
                                setAlert(true);
                                setEdit(v);
                              }}
                            >
                              <FontAwesomeIcon icon={faSave} size="1x" /> Save
                            </Button>
                          </>
                        ) : (
                          <Button
                            disabled={v?.list_type !== "user_lists"}
                            className="border-0 btn-transition"
                            outline
                            color="secondary"
                            title="Edit List"
                            onClick={() => {
                              handleOpen(v.id, true);
                              setRecordCount(v?.record_count);
                              setListName(v?.list_name);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} size="1x" /> Edit
                          </Button>
                        )}
                        <Button
                          disabled={v?.list_type !== "user_lists"}
                          className="border-0 btn-transition"
                          outline
                          color="danger"
                          title="Delete List"
                          onClick={() => {
                            setAlert(true);
                            setRecordCount(v?.record_count);
                            setSpecificListId(v?.id);
                          }}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} size="1x" /> Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
            {myLists.length === 0 && (
              <Col xs="12" className="text-center">
                <h6 className="fw-bold">No Lists to show</h6>
              </Col>
            )}
            <Col xs="6">
              <Button
                block
                outline
                className=" btn-wide btn-transition"
                color="secondary"
                onClick={toggleShow}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="6">
              <Button
                block
                outline
                className=" btn-wide btn-transition"
                color="primary"
                onClick={addList}
              >
                Add List
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      {alert && (
        <Portal id="sweet-alert-portal">
          <SweetAlert
            title="Are you sure?"
            show={alert}
            type={edit ? "warning" : "danger"}
            onConfirm={() => (edit ? editMylist(edit) : deleteList())}
            onCancel={() => {
              setAlert(false);
            }}
            showCancel
            confirmBtnText={edit ? "Yes, Update it!" : "Yes, Delete it!"}
            confirmBtnBsStyle={edit ? "warning" : "danger"}
            cancelBtnBsStyle="info"
          >
            <span className="fw-bold">
              This list contains {recordCount} records.
            </span>
            <br></br>
            You will not be able to recover this!
          </SweetAlert>
        </Portal>
      )}
    </>
  );
}

export default List;
